import { Injectable } from '@angular/core';
import { IResourceFilesProvider } from 'app/interfaces/IResourceFilesProvider';
import { ILogger } from 'app/logger/ILogger';

@Injectable()
export abstract class BaseDataProviderService {
    public abstract setResourceFilesProvider(resourceFilesProvider: IResourceFilesProvider): void;
    public abstract getResourceFilesProvider(): IResourceFilesProvider;
    public abstract getLogger(): ILogger;
    public abstract isGitMode(): boolean;
}
